import { AlternativeRow } from "@/pages/Sbcs/components/Alternatives/alternativeRow";
import { streamlineSolutionFacts } from "@repo/shared/streamline";
import { StreamlineSolution } from "@repo/shared/types";

/** A Streamline solution as a row of the shared alternatives list. */
export const toAlternativeRow = (
  solution: StreamlineSolution,
): AlternativeRow => ({
  id: solution.id,
  tags: solution.tags,
  recommended: solution.isRecommended,
  facts: streamlineSolutionFacts(solution),
});
